import { Button } from "@/design-system";
import { useScreenTitle } from "@/lib/use-screen-title";

import { AuthLayout } from "./AuthLayout";

export interface CheckEmailProps {
  email: string | null;
  onLogin: () => void;
}

export function CheckEmail({ email, onLogin }: CheckEmailProps) {
  useScreenTitle("Controlla la tua email");
  return (
    <AuthLayout
      title="Controlla la tua email"
      subtitle={
        email
          ? `Ti abbiamo inviato un link di conferma a ${email}. Clicca dentro per attivare il tuo account.`
          : "Ti abbiamo inviato un link di conferma. Clicca dentro per attivare il tuo account."
      }
    >
      <p className="text-[13px] text-ink-faint leading-[1.55] mb-6">
        Non vedi nulla? Controlla la cartella spam. Se il link è scaduto, accedi
        e te ne invieremo uno nuovo.
      </p>
      <Button variant="ghost" full onClick={onLogin}>
        Vai al login
      </Button>
    </AuthLayout>
  );
}
